import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { uploadFile } from '@/store/services/commonServices';
import { getBankDetailById, updateBankDetail } from '@/store/services/paymentServices';
import { BankDetailForm } from '@/components/Forms/BankDetailForm';
import Notify from '@/components/Notification';
import { APP_LINKS } from '@/helpers/links';

export const BankDetailUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const { t } = useTranslation('bank-accounts');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await getBankDetailById(id);
    res?.success && setData(res.data);
  };

  const onSubmit = async (values, { setSubmitting }) => {
    const payload = {
      main_account_type: values.account_type.value,
      country: values.country.label,
      country_code: values.country.code,
      beneficiary_name: values.beneficiary_name,
      account_number: values.account_number,
      account_currency: values.account_currency.value,
    };

    if (values.files[0]) {
      const file = values.files[0];
      if (file.id) {
        payload.bank_statement = file.id;
      } else {
        const result = await uploadFile(file);
        if (result?.success) {
          payload.bank_statement = result.data.id;
        }
      }
    }

    if (!values.in_sepa_zone) {
      payload.swift = values.swift;
      payload.beneficiary_address = values.beneficiary_address;
      payload.beneficiary_bank = values.beneficiary_bank;
      payload.beneficiary_bank_address = values.beneficiary_bank_address;
    }

    const res = await updateBankDetail(values.id, payload);

    if (res?.success) {
      return navigate(APP_LINKS.bankAccounts);
    }

    Notify.error({
      text: res.message || t('bank_details_form.submit_error'),
    });
    setSubmitting(false);
  };

  if (!data) {
    return null;
  }

  return <BankDetailForm data={data} onSubmit={onSubmit} />;
};
